import { SafeHtml } from '@angular/platform-browser';

export class MapLegendItems {
  name: string;
  layerType: string;
  items: ItemsDescription[];
  uom?: string;
}

export class ItemsDescription {
  rangeDefinition: string;
  color: string;
  iconPath?: SafeHtml;
}
